/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Category_ComplianceInputs */



/**
* | output |
* | --- |
* | "Compliance" |
*
* @param {Agent_Templates_Category_ComplianceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_category_compliance = /** @type {((inputs?: Agent_Templates_Category_ComplianceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Category_ComplianceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance")
	return /** @type {LocalizedString} */ ("Compliance")
});